export default __webpack_public_path__ + "static/media/Arcade.6dbf2b0e.svg";